var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F39200",
    clipPath: "url(#pen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.54 11.173.848-3.055 5.636-5.636 2.414 2.414-5.636 5.636-3.055.847a.167.167 0 0 1-.206-.206M9.971.997l.952.952a1.035 1.035 0 0 1 0 1.463l-.554.554-2.414-2.414.554-.555a1.035 1.035 0 0 1 1.462 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.535.694h10.69v10.691H.536z"
  })))));
};
export default SvgPen;